import { useState, useEffect } from 'react';
import supabase from '../supabase/supabase';

export const useHome = () => {
  const [featuredArtists, setFeaturedArtists] = useState([]);
  const [latestReleases, setLatestReleases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHomeData();
  }, []);

  const fetchHomeData = async () => {
    setLoading(true);
    try {
      const [artistsRes, releasesRes] = await Promise.all([
        supabase
          .from('d2f_artists')
          .select('id, name, slug, genre, cover_image, avatar_image, supporter_count, verified')
          .order('supporter_count', { ascending: false })
          .limit(6),
        supabase
          .from('d2f_releases')
          .select('id, title, type, cover_image, is_exclusive, release_date, d2f_artists(name, slug)')
          .order('release_date', { ascending: false })
          .limit(8)
      ]);
      setFeaturedArtists(artistsRes.data || []);
      setLatestReleases(releasesRes.data || []);
    } catch {
      setFeaturedArtists([]);
      setLatestReleases([]);
    } finally {
      setLoading(false);
    }
  };

  return { featuredArtists, latestReleases, loading };
};